"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Context {
    constructor(parent) {
        this.parent = parent;
        this.map = new Map();
    }
    get(c) {
        let existing = this.map.get(c);
        if (!existing) {
            existing = this.parent ? this.parent.get(c) : c.ctor();
            this.map.set(c, existing);
        }
        return existing;
    }
    withUpdated(c, update) {
        const updated = new Context(this);
        const old = this.get(c);
        updated.map.set(c, update(old));
        return updated;
    }
}
exports.Context = Context;
class DomainContext {
    constructor(ctor) {
        this.ctor = ctor;
    }
}
exports.objectContext = new DomainContext(() => new ObjectContext(0));
class ObjectContext {
    constructor(depth) {
        this.depth = depth;
    }
    increaseDepth() {
        return new ObjectContext(this.depth + 1);
    }
}
//# sourceMappingURL=Context.js.map